var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { lightness } from '../Helpers/ColorUtils';
export var getTextInputSx = function (size) {
    return __assign(__assign({}, baseTextInputSx), { fontSize: size === 'small' ? 1 : 2, height: size === 'large' ? '3rem' : '2.5rem' });
};
export var baseTextInputSx = {
    fontFamily: 'inherit',
    fontSize: 2,
    color: 'black',
    border: '1px solid',
    borderColor: 'gray-20',
    backgroundColor: 'white',
    borderRadius: 3,
    paddingLeft: 3,
    paddingRight: 3,
    transition: 'border linear 0.2s',
    '&:hover': {
        borderColor: 'gray-40',
    },
    '&:focus': {
        outlineStyle: 'solid',
        outlineColor: 'transparent',
        borderColor: 'gray-70',
        transition: 'none', // Go to the focus border instantly
    },
    '&:disabled': {
        backgroundColor: 'divider-extra-light',
        color: 'gray-40',
        cursor: 'not-allowed',
        '&:hover': {
            borderColor: 'gray-20',
        },
    },
    '&[aria-invalid="true"]': {
        borderColor: 'error',
        '&:hover': {
            borderColor: lightness('error', 0.4),
        },
        '&:focus': {
            borderColor: 'primary',
        },
    },
    '&::placeholder': {
        color: 'gray-60',
    },
};
export var textInputErrorSx = {
    borderColor: 'error',
    '&:hover': {
        borderColor: lightness('error', 0.4),
    },
    '&:focus': {
        borderColor: 'primary',
    },
    '&::placeholder': {
        color: 'gray',
    },
};
export var textInputRowErrorSx = __assign({ fontFamily: 'inherit', fontSize: 2, color: 'black', border: '1px solid', borderRadius: 2, height: '3rem', paddingLeft: 3, paddingRight: 3, transition: 'border linear 0.2s, box-shadow linear 0.2s' }, textInputErrorSx);
export var getHelperTextSx = function (helperTextColor, validationState) {
    return {
        fontSize: 1,
        fontWeight: 3,
        lineHeight: 'normal',
        color: validationState === 'invalid' ? 'error' : helperTextColor,
        paddingTop: 1,
        display: 'flex',
        alignItems: 'center',
    };
};
export var getHelperTextIconSx = function () {
    return {
        marginRight: 1,
        display: 'flex',
    };
};
// To be used in css: className="v-text-input-container"
export var textInputContainerSx = {
    display: 'flex',
    flexDirection: 'column',
};
// To be used in react: label=""
export var textInputLabelSx = {
    textTransform: 'uppercase',
    fontSize: 0,
    fontWeight: 3,
    fontStyle: 'normal',
    verticalAlign: 'middle',
    color: 'gray-70',
    letterSpacing: 'tracked',
    lineHeight: 'copy',
};
// To be used in css: className="v-text-input-label"
export var spacedTextInputLabelSx = __assign(__assign({}, textInputLabelSx), { lineHeight: 'third', paddingBottom: 1 });
export var textInputAreaSx = {
    outline: '0',
    fontSize: 2,
    boxShadow: 0,
    borderRadius: 2,
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: 'gray-20',
    paddingLeft: 3,
    paddingRight: 3,
    fontFamily: 'inherit',
    transition: 'border linear 0.2s, box-shadow linear 0.2s',
    paddingTop: 3,
    '&:hover': {
        borderColor: 'gray-40',
        borderStyle: 'solid',
        borderWidth: '1px',
    },
    '&:focus': {
        outline: '1px solid transparent',
        borderColor: 'primary',
        transition: 'none',
        boxShadow: function (theme) { var _a, _b; return "0 0 0 2px ".concat((_a = theme.colors) === null || _a === void 0 ? void 0 : _a.primary, ", ").concat((_b = theme.shadows) === null || _b === void 0 ? void 0 : _b[0]); },
    },
    '&:disabled': {
        backgroundColor: 'gray-10',
        color: 'gray-40',
        cursor: 'not-allowed',
    },
};
